import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'modFleet'
})
export class ModFleetPipe implements PipeTransform {

  private fleets = {
    1: 'MD11',
    6: 'Airbus',
    8: 'MD10',
    9: 'Multi',
    F: 'B757',
    G: 'B777',
    H: 'B767'
  };

  transform(value: string, ...args: unknown[]): string {
    let returnValue = value;

    Object.keys(this.fleets).forEach(key => {
      returnValue = returnValue.replace(key, this.fleets[key]);
    });

    return  returnValue;
  }

}
